const FormInput = ({ label, id, value, onChange, background }) => {
    const type = id === "box_code" || id === "opening_stock" ? "number" : "text";

    return (
        <div className="grid grid-cols-[40%_60%] md:grid-cols-[35%_65%] items-center gap-2">
            <label htmlFor={id} className="font-bold text-xs sm:text-sm">
                {label} :
            </label>
            <input
                id={id}
                type={type}
                value={value}
                onChange={(e) => onChange(e.target.value)}
                className="w-full border-[2px] border-black rounded px-2 py-1 text-xs sm:text-sm 
                   shadow-[inset_2px_2px_0_rgba(0,0,0,0.25)] 
                   focus:outline-none focus:ring-2 focus:ring-black"
                style={{ backgroundColor: background }}
            />
        </div>
    );
};

export default FormInput;
